import React, { Component } from 'react';
import { Grid, Segment, Form, Button, Header, Divider } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import * as SimpleReactValidator from 'simple-react-validator';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';
import { NotificationManager } from 'react-notifications';
import { getIdentityGroup, createOrUpdateIdentityGroup, getTemplates } from '../../utils/rest';
import VirtualizedSelect from 'react-virtualized-select';

import 'react-select/dist/react-select.css';
import '../../../css/virtual-select.css';

const initialState = {
    iimId: 0,
    iimGroupName: "",
    iimLimId: "",
    iimActive: "Y",
    corporateIds: []
}

class AddIdentityGroup extends Component {

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            loading: true,
            initialState: initialState,
            identityGroup: initialState,
            templates: [],
            errorMessage: [],
            notifications: [],
            open: false
        }
    }

    componentDidMount() {

        getTemplates().then(response => {
            if (response !== null) {
                this.setState({ templates: response });
            }
        })

        if (this.props.params.id > 0) {
            this.props.addItem("helpFile", "identity-mapping-edit.md");
            getIdentityGroup(this.props.params.id).then(response => {
                if (response !== null) {
                    this.setState({ identityGroup: response, loading: false });
                }
            })
        } else {
            this.props.addItem("helpFile", "identity-mapping-add.md");
            this.setState({ loading: false })
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e) => {
        this.setState({
            identityGroup: {
                ...this.state.identityGroup,
                [e.target.name]: e.target.value
            }
        })
    }

    handleCheckbox = (e, { name, checked }) => {
        this.setState({
            identityGroup: {
                ...this.state.identityGroup,
                [name]: (checked) ? "Y" : "N"
            }
        });
    }

    reset = (e) => {
        e.preventDefault();
        this.setState({
            identityGroup: this.state.initialState
        });
    }

    close = () => {
        this.setState({
            open: false
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.validator.allValid()) {
            this.setState({
                loading: true
            });
            createOrUpdateIdentityGroup(this.state.identityGroup).then(response => {
                    if (response !== null) {
                        NotificationManager.success('Success', 'Updated successfully.');
                        this.setState({
                            loading: false
                        }, () => { this.props.history.push("/clientmap") });
                    }else{
                        this.setState({ loading: false })
                    }
            }).catch((error) => {
                this.setState({ loading: false })
            })
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                open: true
            })
            this.forceUpdate();
        }
    }

    resetTemplate = (e) => {
        this.setState({
            identityGroup: {
                ...this.state.identityGroup,
                iimLimId: e.value
            }
        })
    }

    resetCorporate = (e) => {
        
        const ids = e.map((item) => { return item.value })

        this.setState({
            identityGroup: {
                ...this.state.identityGroup,
                corporateIds: ids
            }
        })
    }

    render() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        const { activeIndex } = this.state
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Admnistration" child={[{ name: "Identity", url: "/identity" }, { name: this.props.params.id > 0 ? "Edit Identity" : "Add Identity", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Segment.Group>
                                    <Segment>
                                        <Header as="h4">Group Details</Header>
                                        <Divider></Divider>
                                        <Form.Group>
                                            <Form.Field width={5} className="required">
                                                <label>Group Name:</label>
                                                <Form.Input placeholder='Group Name' required={true} value={this.state.identityGroup.iimGroupName || ''} name="iimGroupName" onChange={this.handleChange} />
                                                {this.validator.message('Group Name', this.state.identityGroup.iimGroupName, 'required')}
                                            </Form.Field>
                                            <Form.Field width={6} className="required">
                                                <label>Select Template</label>
                                                <VirtualizedSelect fluid
                                                    autosize={false}
                                                    onChange={this.resetTemplate} multi={false}
                                                    value={this.state.identityGroup.iimLimId} placeholder={'Select Template'}
                                                    options={this.state.templates.map(template => ({
                                                        key: template.limId,
                                                        value: template.limId,
                                                        label: template.limTemplateName
                                                    }))}>
                                                </VirtualizedSelect>
                                                {this.validator.message('Template', this.state.identityGroup.iimLimId, 'required')}
                                            </Form.Field>
                                            <Form.Field width={6} className="required">
                                                <label>Select Corporate(s)</label>
                                                <VirtualizedSelect fluid
                                                    autosize={false}
                                                    onChange={this.resetCorporate} multi={true}
                                                    value={this.state.identityGroup.corporateIds} placeholder={'Select Corporate(s)'}
                                                    options={this.props.items.corporate}>
                                                </VirtualizedSelect>
                                                {this.validator.message('Corporate', this.state.identityGroup.corporateIds, 'required')}
                                            </Form.Field>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Field width={4}>
                                                <Form.Checkbox label="Active Status (Is Group Active?)" checked={this.state.identityGroup.iimActive === 'Y' ? true : false} name="iimActive" onChange={this.handleCheckbox} />
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>
                                </Segment.Group>
                                <Form.Group>
                                    <Form.Field width={16}>
                                        <Button.Group width={2} className="small right floated">
                                            <Button onClick={this.reset}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit} >{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={11} open={this.state.open} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }
}

export default AddIdentityGroup;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/AddIdentityGroup.js